/* assets/rgd-featured-atc.js */
(function () {
  if (window.__RGD_FEATURED_ATC_JS__) return;
  window.__RGD_FEATURED_ATC_JS__ = true;

  var DEBUG = false;
  function log(){ if (!DEBUG) return; try { console.log.apply(console, arguments); } catch(e){} }
  function warn(){ try { console.warn.apply(console, arguments); } catch(e){} }

  function qs(sel, root){ return (root || document).querySelector(sel); }
  function qsa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function sleep(ms){ return new Promise(function(res){ setTimeout(res, ms); }); }

  function formatMoneyFromShopify(cents){
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify.money_format) || 'R$ {{amount_with_comma_separator}}';
        return window.Shopify.formatMoney(Number(cents || 0), fmt);
      }
    } catch(e){}
    var v = (Number(cents || 0) / 100);
    try { return v.toLocaleString('pt-BR', { style:'currency', currency:'BRL' }); }
    catch(e2){ return 'R$ ' + v.toFixed(2).replace('.', ','); }
  }

  function escapeHtml(s){
    return String(s || '')
      .replace(/&/g,'&amp;')
      .replace(/</g,'&lt;')
      .replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;')
      .replace(/'/g,'&#039;');
  }

  // =========================
  // Drawer selectors (fixos)
  // =========================
  function getDrawerRoot(){ return qs('#CartDrawer'); }
  function getCartContainer(root){ return qs('#CartContainer', root || getDrawerRoot() || document); }
  function getScrollable(root){
    var c = getCartContainer(root);
    return c ? qs('.drawer__scrollable', c) : null;
  }
  function getUpsell(root){
    var c = getCartContainer(root);
    return c ? qs('#RGDCartUpsell', c) : null;
  }
  function getRealFooter(root){
    var c = getCartContainer(root);
    if (!c) return null;
    // footer real do tema (não criado por nós)
    var f = qs('.drawer__footer', c);
    if (f && f.getAttribute('data-rgd-footer') !== '1') return f;
    return null;
  }
  function getRGDFooter(root){
    var c = getCartContainer(root);
    if (!c) return null;
    return qs('.drawer__footer[data-rgd-footer="1"]', c);
  }

  function tryOpenDrawer(){
    var triggers = [
      '.js-drawer-open-cart',
      '[data-drawer-open="cart"]',
      '[data-cart-drawer-open]',
      '[aria-controls="CartDrawer"]',
      '#CartDrawerToggle'
    ];
    for (var i = 0; i < triggers.length; i++){
      var el = qs(triggers[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }

  async function waitForDrawer(){
    for (var i = 0; i < 14; i++){
      var root = getDrawerRoot();
      var c = root ? getCartContainer(root) : null;
      if (root && c) return true;
      await sleep(80);
    }
    return false;
  }

  // =========================
  // Footer injection (o que você pediu)
  // =========================
  function buildFooterHTML(){
    // OBS: action/method já estão no <form class="drawer__contents"> do tema.
    // Aqui só criamos o bloco visual com o submit.
    return ''
      + '<div class="drawer__footer appear-animation appear-delay-5" data-rgd-footer="1">'
      + '  <div class="grid grid--full">'
      + '    <div class="grid__item one-half">'
      + '      <p class="ajaxcart__subtotal">Subtotal</p>'
      + '    </div>'
      + '    <div class="grid__item one-half text-right">'
      + '      <p class="ajaxcart__price">—</p>'
      + '    </div>'
      + '  </div>'
      + '  <p class="ajaxcart__note">Cupons, cadastro e frete serão solicitados no check-out.</p>'
      + '  <button type="submit" class="btn btn--full cart__checkout" name="checkout">Finalizar compra</button>'
      + '</div>';
  }

  function ensureFooter(){
    var root = getDrawerRoot();
    if (!root) return;

    var c = getCartContainer(root);
    if (!c) return;

    // Se o tema renderizou footer real, removemos o nosso (evita duplicar)
    var real = getRealFooter(root);
    if (real) {
      var ours = getRGDFooter(root);
      if (ours && ours.parentNode) ours.parentNode.removeChild(ours);
      return;
    }

    // Se já existe o nosso, ok
    if (getRGDFooter(root)) return;

    // Cria o footer no final do #CartContainer
    var tmp = document.createElement('div');
    tmp.innerHTML = buildFooterHTML();
    var footer = tmp.firstChild;
    c.appendChild(footer);
  }

  function updateFooterSubtotal(cart){
    var root = getDrawerRoot();
    if (!root) return;

    // atualiza footer real se existir; senão atualiza o nosso
    var footer = getRealFooter(root) || getRGDFooter(root);
    if (!footer) return;

    var priceEl = qs('.ajaxcart__price', footer);
    if (!priceEl) return;

    priceEl.textContent = formatMoneyFromShopify((cart && cart.total_price) || 0);
  }

  // =========================
  // Cart API
  // =========================
  async function fetchCartJSON(){
    var res = await fetch('/cart.js?rgd_t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!res.ok) throw new Error('Falha em /cart.js (HTTP ' + res.status + ')');
    return await res.json();
  }

  async function addToCart(variantId){
    var res = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });

    if (!res.ok) {
      var msg = 'Não foi possível adicionar.';
      try {
        var data = await res.json();
        if (data && data.description) msg = data.description;
      } catch(e){}
      throw new Error(msg);
    }

    try { await res.json(); } catch(e){}
  }

  async function changeLineQuantity(lineKey, newQty){
    var payload = { id: String(lineKey), quantity: Math.max(0, Number(newQty || 0)) };

    var res = await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify(payload)
    });

    if (!res.ok) {
      var txt = '';
      try { txt = await res.text(); } catch(e){}
      throw new Error('Falha /cart/change.js (HTTP ' + res.status + '): ' + (txt || 'sem corpo'));
    }

    return await res.json().catch(function(){ return null; });
  }

  // =========================
  // Render products ONLY in .drawer__scrollable
  // =========================
  function cleanupEmptyState(scrollable){
    if (!scrollable) return;
    var ps = qsa('p', scrollable);
    for (var i = 0; i < ps.length; i++){
      var txt = (ps[i].textContent || '').trim().toLowerCase();
      if (txt.indexOf('seu carrinho') !== -1 && txt.indexOf('vazio') !== -1) {
        ps[i].parentNode && ps[i].parentNode.removeChild(ps[i]);
      }
    }
  }

  function buildItemHTML(item, idx){
    var url = item.url || ('/products/' + (item.handle || ''));
    var img = item.image ? String(item.image) : '';
    if (img) img = img.replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_180x$1$3');

    var title = item.product_title || item.title || 'Produto';
    var line = item.key;
    var qty = item.quantity || 1;
    var price = (item.final_line_price != null) ? item.final_line_price : (item.line_price != null ? item.line_price : 0);
    var appearDelay = 3 + (idx * 2);

    var svgMinus = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-minus" viewBox="0 0 20 20"><path fill="#444" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"></path></svg>';
    var svgPlus  = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 20 20"><path fill="#444" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"></path></svg>';

    return ''
      + '<div class="ajaxcart__product appear-animation appear-delay-' + appearDelay + '" data-rgd-line="' + escapeHtml(line) + '">'
      + '  <div class="ajaxcart__row">'
      + '    <div class="grid">'
      + '      <div class="grid__item one-third">'
      + '        <a href="' + escapeHtml(url) + '" class="ajaxcart__product-image">'
      +           (img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '">' : '')
      + '        </a>'
      + '      </div>'
      + '      <div class="grid__item two-thirds">'
      + '        <div class="ajaxcart__product-name--wrapper">'
      + '          <a href="' + escapeHtml(url) + '" class="ajaxcart__product-name">' + escapeHtml(title) + '</a>'
      + '        </div>'
      + '        <div class="grid grid--full display-table">'
      + '          <div class="grid__item display-table-cell one-half">'
      + '            <div class="ajaxcart__quantity">'
      + '              <label class="visually-hidden">Quantidade</label>'
      + '              <div class="js-qty__wrapper">'
      + '                <input type="text" class="js-qty__num" value="' + qty + '" data-rgd-line="' + escapeHtml(line) + '" min="0" aria-label="quantity" pattern="[0-9]*">'
      + '                <button type="button" class="js-qty__adjust js-qty__adjust--minus" aria-label="Reduzir quantidade em uma unidade" data-rgd-qty="minus" data-rgd-line="' + escapeHtml(line) + '">'
      +                    svgMinus
      + '                  <span class="icon__fallback-text" aria-hidden="true">−</span>'
      + '                </button>'
      + '                <button type="button" class="js-qty__adjust js-qty__adjust--plus" aria-label="Aumentar quantidade em uma unidade" data-rgd-qty="plus" data-rgd-line="' + escapeHtml(line) + '">'
      +                    svgPlus
      + '                  <span class="icon__fallback-text" aria-hidden="true">+</span>'
      + '                </button>'
      + '              </div>'
      + '            </div>'
      + '          </div>'
      + '          <div class="grid__item display-table-cell one-half text-right">'
      + '            <span class="ajaxcart__price">' + escapeHtml(formatMoneyFromShopify(price)) + '</span>'
      + '          </div>'
      + '        </div>'
      + '        <div class="grid grid--full display-table"></div>'
      + '      </div>'
      + '    </div>'
      + '  </div>'
      + '</div>';
  }

  function renderProductsOnly(cart){
    var scrollable = getScrollable();
    if (!scrollable) throw new Error('Não encontrei .drawer__scrollable dentro de #CartContainer.');

    // remove produtos antigos
    var old = qsa('.ajaxcart__product', scrollable);
    for (var i = 0; i < old.length; i++){
      old[i].parentNode && old[i].parentNode.removeChild(old[i]);
    }

    // remove texto de carrinho vazio
    cleanupEmptyState(scrollable);

    // injeta produtos
    var items = (cart && cart.items) ? cart.items : [];
    var frag = document.createDocumentFragment();

    for (var j = 0; j < items.length; j++){
      var tmp = document.createElement('div');
      tmp.innerHTML = buildItemHTML(items[j], j);
      while (tmp.firstChild) frag.appendChild(tmp.firstChild);
    }

    scrollable.appendChild(frag);
  }

  // =========================
  // Qty controls
  // =========================
  function bindQtyControls(){
    if (document.documentElement.dataset.rgdFeaturedQtyBound === '1') return;
    document.documentElement.dataset.rgdFeaturedQtyBound = '1';

    document.addEventListener('click', async function(e){
      var btn = e.target.closest('[data-rgd-qty]');
      if (!btn) return;

      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();

      var line = btn.getAttribute('data-rgd-line');
      if (!line) return;

      if (btn.dataset.loading === '1') return;
      btn.dataset.loading = '1';
      btn.disabled = true;

      try {
        var cartNow = await fetchCartJSON();
        var items = (cartNow && cartNow.items) ? cartNow.items : [];
        var curQty = null;

        for (var i = 0; i < items.length; i++){
          if (items[i] && items[i].key === line) { curQty = Number(items[i].quantity || 0); break; }
        }
        if (curQty === null) throw new Error('Linha não encontrada no carrinho: ' + line);

        var dir = btn.getAttribute('data-rgd-qty');
        var next = (dir === 'plus') ? (curQty + 1) : (curQty - 1);
        next = Math.max(1, next);

        var cart = await changeLineQuantity(line, next);
        if (!cart) cart = await fetchCartJSON();

        ensureFooter();              // ✅ cria footer se faltar
        renderProductsOnly(cart);    // ✅ só produtos
        updateFooterSubtotal(cart);  // ✅ subtotal no footer real ou nosso

      } catch(err){
        warn(err);
        alert(err && err.message ? err.message : 'Erro ao atualizar quantidade.');
      } finally {
        btn.disabled = false;
        delete btn.dataset.loading;
      }
    }, true);
  }

  // =========================
  // Featured ATC click
  // =========================
  document.addEventListener('click', async function(e){
    var btn = e.target.closest('[data-rgd-atc]');
    if (!btn) return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    if (btn.dataset.loading === '1') return;
    btn.dataset.loading = '1';

    var oldText = btn.textContent;
    btn.textContent = 'Adicionando...';
    btn.disabled = true;

    try {
      await addToCart(variantId);

      tryOpenDrawer();
      await waitForDrawer();

      var cart = await fetchCartJSON();

      ensureFooter();              // ✅ injeta footer no final se não existir
      renderProductsOnly(cart);    // ✅ renderiza produtos
      updateFooterSubtotal(cart);  // ✅ atualiza subtotal

      btn.textContent = 'Adicionado ✓';
      setTimeout(function(){
        btn.textContent = oldText;
        btn.disabled = false;
        delete btn.dataset.loading;
      }, 900);

    } catch(err){
      warn(err);
      alert(err && err.message ? err.message : 'Erro ao adicionar.');
      btn.textContent = oldText;
      btn.disabled = false;
      delete btn.dataset.loading;
    }
  });

  // Boot
  bindQtyControls();

  // ✅ watcher leve: se o tema renderizar footer real depois, remove o nosso
  // (evita duplicar quando o tema “acorda”)
  var mo = new MutationObserver(function(){
    try { ensureFooter(); } catch(e){}
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();